import { DatePipe } from "@angular/common";
import moment from "moment";

export default class DateTimeHelper {
  static addTimeToDate(date: Date | null, time: string | null): Date | null {
    if (date) {
      let newDate: Date = new Date(date);

      if (time) {
        const parts = time.split(':');
        const hours = Number(parts[0]);
        const minutes = Number(parts[1]);

        newDate.setHours(hours, minutes, 0, 0);
      }

      return newDate;
    }

    return null;
  }

  static getTimeFromDate(datePipe: DatePipe, date: Date | null): string | null {
    return datePipe.transform(date, 'HH:mm');
  }

  static getDateOnly(date: Date): Date {
    return new Date(date.toDateString());
  }

  static getlocalDateOnlyFromUTC(date: Date): Date {
    const result = new Date(date);
    result.setHours(0);
    result.setMinutes(0);

    return result;
  }

  static addDays(date: Date, days: number): Date {
    let result = new Date(date);
    result.setDate(result.getDate() + days);

    return result;
  }

  static addMonths(date: Date, months: number): Date {
    let result = new Date(date);
    result.setMonth(date.getMonth() + months);

    return result;
  }

  static addHours(date: Date, hours: number): Date {
    let result = new Date(date);
    result.setHours(date.getHours() + hours);

    return result;
  }
  
  static addMinutes(date: Date, minutes: number): Date {
    let result = new Date(date);
    result.setMinutes(date.getMinutes() + minutes);

    return result;
  }

  static getFirstDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  static getLastDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  static getDateFromMomentOrDate(date: any): Date {
    if (date instanceof moment) {
      return moment(date).toDate();
    }

    // Could also be a string
    return new Date(date);
  }

  static getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  static getStartOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  static getDateOrDefault(value: Date | string | null): Date | null {
    if(!value) {
      return null;
    }

    if (value instanceof moment) {
      return moment(value).toDate();
    }

    return new Date(value);
  }

  public static isDateString(value) {
    if (value === null || value === undefined || typeof value !== 'string') {
      return false;
    }

    const regex = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/;

    return regex.test(value);
  }
}
